import React from 'react';
import './styles.css';

const AnimatedBrainLoader = ({ size = 80, className = "" }) => {
    return (
        <div className={`animated-brain-loader ${className}`} style={{ width: size, height: size }}>
            <svg
                viewBox="0 0 100 100"
                className="brain-svg"
                xmlns="http://www.w3.org/2000/svg"
            >
                {/* Brain outline */}
                <path
                    d="M50 15 C35 15, 20 25, 20 40 C20 45, 22 50, 25 55 C22 60, 20 65, 20 70 C20 80, 30 85, 40 85 C45 90, 55 90, 60 85 C70 85, 80 80, 80 70 C80 65, 78 60, 75 55 C78 50, 80 45, 80 40 C80 25, 65 15, 50 15 Z"
                    className="brain-outline"
                    fill="none"
                    stroke="#8E51FF"
                    strokeWidth="2"
                />
                
                {/* Neural pathways */}
                <g className="neural-pathways">
                    <path
                        d="M30 30 Q40 25, 50 30 Q60 25, 70 30"
                        className="neural-path neural-path-1"
                        fill="none"
                        stroke="#8E51FF"
                        strokeWidth="1"
                        opacity="0.6"
                    />
                    <path
                        d="M25 45 Q35 40, 45 45 Q55 40, 65 45 Q75 40, 80 45"
                        className="neural-path neural-path-2"
                        fill="none"
                        stroke="#8E51FF"
                        strokeWidth="1"
                        opacity="0.6"
                    />
                    <path
                        d="M30 60 Q40 55, 50 60 Q60 55, 70 60"
                        className="neural-path neural-path-3"
                        fill="none"
                        stroke="#8E51FF"
                        strokeWidth="1"
                        opacity="0.6"
                    />
                </g>
                
                {/* Synapses (connection points) */}
                <g className="synapses">
                    <circle cx="30" cy="30" r="2" className="synapse synapse-1" fill="#8E51FF" />
                    <circle cx="50" cy="30" r="2" className="synapse synapse-2" fill="#8E51FF" />
                    <circle cx="70" cy="30" r="2" className="synapse synapse-3" fill="#8E51FF" />
                    <circle cx="25" cy="45" r="1.5" className="synapse synapse-4" fill="#8E51FF" />
                    <circle cx="45" cy="45" r="1.5" className="synapse synapse-5" fill="#8E51FF" />
                    <circle cx="65" cy="45" r="1.5" className="synapse synapse-6" fill="#8E51FF" />
                    <circle cx="80" cy="45" r="1.5" className="synapse synapse-7" fill="#8E51FF" />
                    <circle cx="30" cy="60" r="2" className="synapse synapse-8" fill="#8E51FF" />
                    <circle cx="50" cy="60" r="2" className="synapse synapse-9" fill="#8E51FF" />
                    <circle cx="70" cy="60" r="2" className="synapse synapse-10" fill="#8E51FF" />
                </g>
                
                {/* Brain waves */}
                <g className="brain-waves">
                    <path
                        d="M15 20 Q20 15, 25 20 Q30 15, 35 20"
                        className="brain-wave brain-wave-1"
                        fill="none"
                        stroke="#8E51FF"
                        strokeWidth="1"
                        opacity="0.4"
                    />
                    <path
                        d="M65 20 Q70 15, 75 20 Q80 15, 85 20"
                        className="brain-wave brain-wave-2"
                        fill="none"
                        stroke="#8E51FF"
                        strokeWidth="1"
                        opacity="0.4"
                    />
                    <path
                        d="M10 50 Q15 45, 20 50 Q25 45, 30 50"
                        className="brain-wave brain-wave-3"
                        fill="none"
                        stroke="#8E51FF"
                        strokeWidth="1"
                        opacity="0.4"
                    />
                    <path
                        d="M70 50 Q75 45, 80 50 Q85 45, 90 50"
                        className="brain-wave brain-wave-4"
                        fill="none"
                        stroke="#8E51FF"
                        strokeWidth="1"
                        opacity="0.4"
                    />
                </g>
                
                {/* Floating ideas particles */}
                <g className="idea-particles">
                    <circle cx="15" cy="35" r="1" className="particle particle-1" fill="#8E51FF" opacity="0.7" />
                    <circle cx="85" cy="25" r="1.5" className="particle particle-2" fill="#8E51FF" opacity="0.7" />
                    <circle cx="10" cy="65" r="1" className="particle particle-3" fill="#8E51FF" opacity="0.7" />
                    <circle cx="90" cy="70" r="1.5" className="particle particle-4" fill="#8E51FF" opacity="0.7" />
                    <circle cx="25" cy="15" r="1" className="particle particle-5" fill="#8E51FF" opacity="0.7" />
                    <circle cx="75" cy="15" r="1.5" className="particle particle-6" fill="#8E51FF" opacity="0.7" />
                </g>
                
                {/* Central glow */}
                <circle
                    cx="50"
                    cy="50"
                    r="35"
                    className="brain-glow"
                    fill="none"
                    stroke="#8E51FF"
                    strokeWidth="0.5"
                    opacity="0.3"
                />
            </svg>
            
            {/* Loading text */}
            <div className="loading-text">
                <span className="loading-dot loading-dot-1">•</span>
                <span className="loading-dot loading-dot-2">•</span>
                <span className="loading-dot loading-dot-3">•</span>
            </div>
        </div>
    );
};

export default AnimatedBrainLoader;
